import {Button, Card, Modal, useMediaQuery, useTheme} from '@mui/material'
import React, {useEffect, useRef, useState} from 'react'
import { makeStyles } from '@material-ui/core/styles'
import CheckIcon from '@material-ui/icons/Check'
import CloseIcon from '@material-ui/icons/Close'
import PDFObject from 'pdfobject'

const styles = makeStyles(theme => ({
  container: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
  },
  btnContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '40px',
    marginTop: 10,
  },
  btnOrange: {
    backgroundColor: '#ff9800 !important',
  },
  cardModal: {
    width: 'calc(100vw - 300px)', height: 'calc(100vh - 150px)',
    [theme.breakpoints.down('800')]: {
      width: '95vw', height: '80vh',
    },
    padding: 20
  },
  cardModalMobile: {
    padding: 20,
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    alignItems: 'center',
  },
  pdfContainer: {
    flex: 1,
    width: '100%',
    height: '100%',
    '& > iframe': {
      width: '100%',
      height: '100%',
      border: 'none',
    },
  },
}))

export default function ReglementModalAppointment({ setStep, reglementModal, setReglementModal }) {
  const classes = styles()
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down('550'));
  const [isClicked, setIsClicked] = useState(!isMobile);

  useEffect(() => {
    setIsClicked(!isMobile)
  }, [isMobile])

  return (
    <Modal open={reglementModal} onClose={() => setReglementModal(false)} sx={{ display: 'grid', placeContent: 'center' }}>
      <Card className={isMobile ? classes.cardModalMobile : classes.cardModal}>
        <div className={classes.container}>
          {!isMobile ? <div className={classes.pdfContainer}>
            <iframe src={'/documents/reglement-interieur.pdf'} title="reglement-interieur" />
          </div> : <div className={classes.container}>
            Pour passer à la suite, veuillez bien lire le règlement intérieur.
            <Button variant="contained" color="primary" href={'/documents/reglement-interieur.pdf'} target="_blank" onClick={() => setIsClicked(true)}>Voir le règlement intérieur</Button>
          </div>}

          <div className={classes.btnContainer}>
            <Button variant="contained"
              color="error" startIcon={<CloseIcon />} onClick={() => {
                setReglementModal(false)
              }}>Refuser</Button>
            <Button variant="contained" color="success" disabled={!isClicked} startIcon={<CheckIcon />} onClick={() => {
              setReglementModal(false)
              setStep(4)
            }}>Confirmer</Button>
          </div>
        </div>
      </Card>
    </Modal>
  )
}
